<div class="blog-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.blogs_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ blogName }}</h2>
    </div>
    <div class="lx-page-actions">
      <button class="lx-btn lx-btn--edit" data-bs-toggle="modal" data-bs-target="#exampleModal">
        <span class="material-symbols-outlined">edit</span>
        {{ 'btn.edit' | translate }}
      </button>
      <button class="lx-btn lx-btn--danger" data-bs-toggle="modal" data-bs-target="#exampleModalTow">
        <span class="material-symbols-outlined">delete</span>
        {{ 'btn.delete' | translate }}
      </button>
    </div>
  </div>

  <div class="app-card blog-meta-card">
    <div class="blog-meta">
      <div class="blog-meta-item">
        <span class="material-symbols-outlined">article</span>
        <div>
          <p class="blog-meta-label">{{ 'blog.content_label' | translate }}</p>
          <p class="blog-meta-value">{{ blogContent }}</p>
        </div>
      </div>
      <div class="blog-meta-item" *ngIf="blogSteps">
        <span class="material-symbols-outlined">format_list_numbered</span>
        <div>
          <p class="blog-meta-label">{{ 'blog.steps_label' | translate }}</p>
          <p class="blog-meta-value">{{ blogSteps }}</p>
        </div>
      </div>
      <div class="blog-meta-item">
        <span class="material-symbols-outlined">calendar_today</span>
        <div>
          <p class="blog-meta-label">{{ 'lbl.published' | translate }}</p>
          <p class="blog-meta-value">{{ blogData | date : "d MMMM y" }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="blog-section">
    <div class="lx-section-header">
      <span class="material-symbols-outlined">inventory_2</span>
      <h3 class="lx-section-title">{{ 'blog.linked_products' | translate }}</h3>
    </div>
    <div class="app-card blog-table-card" *ngIf="!showMessage">
      <div class="lx-table-wrap">
        <table class="lx-table">
          <thead>
            <tr>
              <th>#</th>
              <th>{{ 'lbl.name' | translate }}</th>
              <th>{{ 'lbl.image' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of blogProduct">
              <td class="cell-muted">{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>
                <img class="blog-product-thumb" src="{{ item.image[0].image_url }}" [alt]="item.name" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="lx-empty" *ngIf="showMessage">
      <div class="lx-empty-icon">
        <span class="material-symbols-outlined">inventory_2</span>
      </div>
      <h3>{{ 'empty.blog_products' | translate }}</h3>
      <p>{{ 'empty.blog_products_sub' | translate }}</p>
    </div>
  </div>

  <div class="blog-section" *ngIf="mainArrImages.length > 0">
    <div class="lx-section-header">
      <span class="material-symbols-outlined">photo_library</span>
      <h3 class="lx-section-title">{{ 'prod.images' | translate }}</h3>
    </div>
    <div class="blog-media-grid">
      <div class="blog-media-item" *ngFor="let item of mainArrImages">
        <img class="blog-media-img" src="{{ item.image_url }}" alt="Blog image" />
        <button (click)="DeleteImage(item.id)" class="lx-btn lx-btn--danger blog-delete-btn">
          <span class="material-symbols-outlined">delete</span>
          {{ 'btn.delete' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="blog-section" *ngIf="videosArr.length > 0">
    <div class="lx-section-header">
      <span class="material-symbols-outlined">play_circle</span>
      <h3 class="lx-section-title">{{ 'prod.videos' | translate }}</h3>
    </div>
    <div class="blog-video-grid">
      <div class="blog-video-item" *ngFor="let item of videosArr">
        <video class="blog-video" controls>
          <source src="{{ item.image_url }}" type="video/mp4" />
          <source src="{{ item.image_url }}" type="video/ogg" />
        </video>
        <button (click)="DeleteImage(item.id)" class="lx-btn lx-btn--danger blog-delete-btn">
          <span class="material-symbols-outlined">delete</span>
          {{ 'btn.delete' | translate }}
        </button>
      </div>
    </div>
  </div>

</div>

<!-- ══════════════════════════════════════
     Edit Blog Modal
════════════════════════════════════════ -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--row">
        <div>
          <p class="lx-modal-eyebrow">{{ 'page.blogs_eyebrow' | translate }}</p>
          <h5 class="lx-modal-title">{{ 'blog.edit' | translate }}</h5>
        </div>
        <button type="button" class="lx-modal-close" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="lx-modal-body">
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'blog.title_label' | translate }}</label>
          <input [(ngModel)]="title" type="text" class="lx-input" placeholder="Blog title..." />
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'blog.content_label' | translate }}</label>
          <textarea [(ngModel)]="content" class="lx-input lx-textarea" placeholder="Content..."></textarea>
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'blog.steps_label' | translate }}</label>
          <input [(ngModel)]="steps" type="text" class="lx-input" placeholder="Steps..." />
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'blog.add_images' | translate }}</label>
          <input multiple (change)="uploadFile($event, 'main')" type="file" class="lx-input lx-file-input" />
        </div>
        <div class="lx-field-group">
          <label class="lx-field-label">{{ 'blog.add_video' | translate }}</label>
          <input multiple (change)="uploadFile($event, 'video')" type="file" class="lx-input lx-file-input" />
        </div>
      </div>
      <div class="lx-modal-footer">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button data-bs-dismiss="modal" type="button" (click)="editBlog()" class="lx-btn lx-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_changes' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════
     Delete Blog Modal
════════════════════════════════════════ -->
<div class="modal fade" id="exampleModalTow" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--centered">
        <div class="lx-modal-icon lx-modal-icon--danger">
          <span class="material-symbols-outlined">delete_forever</span>
        </div>
        <h5 class="lx-modal-title">{{ 'confirm.delete_blog' | translate }}</h5>
        <p class="lx-modal-subtitle">
          {{ 'confirm.are_you_sure_delete' | translate }} <strong>{{ blogName }}</strong>?
          {{ 'confirm.cannot_undo' | translate }}
        </p>
      </div>
      <div class="lx-modal-footer lx-modal-footer--centered">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button (click)="DeleteBlog()" data-bs-dismiss="modal" type="button" class="lx-btn lx-btn--danger">
          <span class="material-symbols-outlined">delete</span>
          {{ 'btn.delete' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
